import { TRAVEL_PLANNER_WCAG_TRANSLATION_KEYS } from '../itinerary-legs-overview/itinerary-legs-overview.const';

export const JOURNEY_ITINERARY_WCAG_TRANSLATION_KEYS = {
    JOURNEY_FROM_TO: 'TRAVEL_PLANNER_WCAG_JOURNEY_FROM_TO',
    JOURNEY_ARRIVAL: 'TRAVEL_PLANNER_WCAG_JOURNEY_ARRIVAL',
    JOURNEY_TOTAL_DURATION: 'TRAVEL_PLANNER_WCAG_JOURNEY_TOTAL_DURATION',
    JOURNEY_BOARD_FIRST: 'TRAVEL_PLANNER_WCAG_JOURNEY_BOARD_FIRST',
    JOURNEY_INCLUDES: 'TRAVEL_PLANNER_WCAG_JOURNEY_INCLUDES',
    JOURNEY_LIVE_UPDATES: 'TRAVEL_PLANNER_WCAG_JOURNEY_LIVE_UPDATES',
    ROUTE_NAME: 'TRAVEL_PLANNER_WCAG_ROUTE_NAME',
    MODE_WALKING: 'TRAVEL_PLANNER_WCAG_MODE_WALKING',
    DURATION_HOUR: 'TRAVEL_PLANNER_WCAG_DURATION_HOUR',
    DURATION_HOURS: 'TRAVEL_PLANNER_WCAG_DURATION_HOURS',
    DURATION_MINUTE: 'TRAVEL_PLANNER_WCAG_DURATION_MINUTE',
    DURATION_MINUTES: 'TRAVEL_PLANNER_WCAG_DURATION_MINUTES',
    CHANGE_ONE: 'JOURNEY_PLANNER_CHANGE_ONE',
    CHANGE_MANY: 'JOURNEY_PLANNER_CHANGE_MANY'
} as const;

export const JOURNEY_ITINERARY_REUSED_WCAG_TRANSLATION_KEYS = {
    DEPARTURE_WITH_ORIGINAL: TRAVEL_PLANNER_WCAG_TRANSLATION_KEYS.DEPARTURE_WITH_ORIGINAL,
    DEPARTURE: TRAVEL_PLANNER_WCAG_TRANSLATION_KEYS.DEPARTURE,
    MODE_BUS: TRAVEL_PLANNER_WCAG_TRANSLATION_KEYS.MODE_BUS,
    MODE_TRAM: TRAVEL_PLANNER_WCAG_TRANSLATION_KEYS.MODE_TRAM,
    MODE_TRAIN: TRAVEL_PLANNER_WCAG_TRANSLATION_KEYS.MODE_TRAIN,
    MODE_FERRY: TRAVEL_PLANNER_WCAG_TRANSLATION_KEYS.MODE_FERRY,
    MODE_TROLLEYBUS: TRAVEL_PLANNER_WCAG_TRANSLATION_KEYS.MODE_TROLLEYBUS,
    MODE_FLEXIBLE: TRAVEL_PLANNER_WCAG_TRANSLATION_KEYS.MODE_FLEXIBLE,
    MODE_TRANSPORT: TRAVEL_PLANNER_WCAG_TRANSLATION_KEYS.MODE_TRANSPORT
} as const;
